"use client";

import * as motion from "motion/react-client";
import { useRef } from "react";
import { rh } from "../../../hooks";
import { MotionValue } from "motion/react";

export function Ball({
  size = 100,
  color = "var(--yz-foreground)"
}: {
  size?: number;
  color?: string | MotionValue<string>;
}) {
  const ref = useRef<HTMLDivElement>(null);

  const { x, y } = rh.useFollowPointer(ref);

  return (
    <motion.div
      ref={ref}
      style={{
        width: size,
        height: size,
        backgroundColor: color,
        borderRadius: "50%",
        x,
        y
      }}
    />
  );
}
